import { getPathAdAccountId } from 'utils'
import { MetricIds } from '../../../Columns'

const storageKey = 'dashboardChart'

const defaultMetricColumns = ['viewableImpression', 'click', 'spending', 'ppc']

export const getStorageItem = () =>
  JSON.parse(localStorage.getItem(storageKey)) || {}

export const getSavedChart = () => {
  const storageItem = getStorageItem()
  const adAccountId = getPathAdAccountId()
  const accountChart = storageItem[adAccountId] || defaultMetricColumns
  return accountChart.map((metricId, index) =>
    MetricIds.includes(metricId) ? metricId : defaultMetricColumns[index]
  )
}

export const persistChart = columns => {
  const adAccountId = getPathAdAccountId()
  const storageItem = getStorageItem()
  storageItem[adAccountId] = columns
  localStorage.setItem(storageKey, JSON.stringify(storageItem))
}
